export const environment = {
  production: false,
  apiBaseUrl: 'https://api.rosalie.pixacare.com',
  appInsights: {
    instrumentationKey: 'TODO',
  },
};
